module.exports = __webpack_public_path__ + "img/testimonial-dtac.346e942f.png";